import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { BASE_API_URL } from '../config/app.config';

@Injectable()
export class FileProvider {

  constructor(private http: HttpClient) {}

  getSignedPutURL(file, key): Promise<any> {
    const url = BASE_API_URL + 'files/getSignedPutURL';

    let metadata = {
      name: file.name,
      contentType: file.type
    };

    let body = {
      key: key,
      metadata: metadata,
      isPublic: true
    };

    let promise = new Promise((resolve, reject) => {
      this.http.post(url, body).toPromise()
        .then(res => {
          resolve(res);
        });
    });
    return promise;
  }

  uploadFile(url, file) {
    let params = new HttpParams();

    const options = {
      headers: new HttpHeaders().set('Content-Type', file.type).set('StandardAuthOptOut','true'),
    };

    return this.http.put(url, file, options).toPromise();
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/providers/file.provider.ts